let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4OB9T")).then(() => parcelRequire('5U8C1'));